import { Component, Input } from '@angular/core';
import { ChartLineComponent, ChartLineConfig } from './chart-line.component';

@Component({
  selector: 'app-chart-line-multiple',
  standalone: true,
  template: `
    <div class="grid pt-2 pb-2">
      @for (chart of config; track $index) {
        <div class="col-12 mb-2" [class]="'md:col-' + (chart.col ?? 12)">
          <div class="dash-card h-full">
            @if (chart.title) {
              <div class="dash-header">
                <div class="dash-title">{{ chart.title }}</div>
              </div>
            }
            <div class="dash-body">
              <app-chart-line [config]="chart" [data]="data"/>
            </div>
          </div>
        </div>
      }
    </div>
  `,
  imports: [ChartLineComponent]
})
export class ChartLineMultipleComponent {

  @Input() config: ChartLineConfig[] = [];
  @Input() data: any[] = [];
}
